export default function isNullOrBlank(str) {
  return !str || str.trim().length === 0;
}
